module.exports = __webpack_public_path__ + "img/only-clouds.753cb9c6.svg";